// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkReassignHouseholdsMutationVariables = Types.Exact<{
  inputs: Array<Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>> | Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>;
}>;


export type BulkReassignHouseholdsMutation = { __typename?: 'Mutation', updateHouseholds: Array<{ __typename?: 'Household', id: string, displayName: string, primaryRelationshipOwner: { __typename?: 'User', id: string, displayName: string } } | null> };

export const Operations = {
  Mutation: {
    BulkReassignHouseholds: 'BulkReassignHouseholds' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const BulkReassignHouseholdsDocument = gql`
    mutation BulkReassignHouseholds($inputs: [AugmentedUpdateHouseholdInput]!) {
  updateHouseholds(inputs: $inputs) {
    id
    displayName
    primaryRelationshipOwner {
      id
      displayName
    }
  }
}
    `;
export type BulkReassignHouseholdsMutationFn = Apollo.MutationFunction<BulkReassignHouseholdsMutation, BulkReassignHouseholdsMutationVariables>;

/**
 * __useBulkReassignHouseholdsMutation__
 *
 * To run a mutation, you first call `useBulkReassignHouseholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkReassignHouseholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkReassignHouseholdsMutation, { data, loading, error }] = useBulkReassignHouseholdsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBulkReassignHouseholdsMutation(baseOptions?: Apollo.MutationHookOptions<BulkReassignHouseholdsMutation, BulkReassignHouseholdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkReassignHouseholdsMutation, BulkReassignHouseholdsMutationVariables>(BulkReassignHouseholdsDocument, options);
      }
export type BulkReassignHouseholdsMutationHookResult = ReturnType<typeof useBulkReassignHouseholdsMutation>;
export type BulkReassignHouseholdsMutationResult = Apollo.MutationResult<BulkReassignHouseholdsMutation>;
export type BulkReassignHouseholdsMutationOptions = Apollo.BaseMutationOptions<BulkReassignHouseholdsMutation, BulkReassignHouseholdsMutationVariables>;